import { useQuery } from '@tanstack/react-query';
import { getActiveSocialMediaAccounts } from '@/api/socialMedia';
import { queryKeys } from '@/lib/queryKeys';

/**
 * Hook to fetch active social media accounts for footer display
 */
export const useSocialMediaAccounts = () => {
    return useQuery({
        queryKey: queryKeys.socialMedia.active(),
        queryFn: getActiveSocialMediaAccounts,
        staleTime: 1000 * 60 * 60, // 1 hour - rarely changes
    });
};
